export default {
  translation: {
    nav: {
      home: 'الرئيسية',
      trips: 'الرحلات',
      aboutUs: 'من نحن',
      alerts: 'التنبيهات',
      wishlist: 'المفضلة',
      language: 'اللغة',
      profile: 'الملف الشخصي',
      settings: 'الإعدادات',
      signIn: 'تسجيل الدخول',
      signUp: 'إنشاء حساب'
    },
    hero: {
      title: 'اكتشف أوغندا',
      subtitle: 'وما بعدها',
      description: 'اكتشف لؤلؤة أفريقيا مع المرشدين المحليين الخبراء. تجارب لا تُنسى في انتظارك في المناظر الطبيعية الخلابة والثقافة النابضة بالحياة في أوغندا.',
      searchPlaceholder: 'إلى أين تذهب؟',
      categories: {
        all: 'الكل',
        wildlife: 'الحياة البرية',
        safari: 'سفاري',
        cultural: 'ثقافي',
        adventure: 'مغامرة',
        birding: 'مراقبة الطيور'
      }
    },
    common: {
      from: 'من',
      reviews: 'تقييمات',
      viewMore: 'عرض المزيد',
      book: 'حجز',
      seeAll: 'عرض الكل',
      loading: 'جاري التحميل...'
    }
  }
};